import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'
import './Loading.css'

const Loading = () => {
    const { t } = useTranslation()

    return (
        <div className="Loading-wrapper">
            <div className="Loading-helper-text">{t('Načítání')}</div>
            <div className="Loading-ripple"><div></div><div></div></div>
        </div>
    )
}

Loading.propTypes = {
}

export default Loading
